export const types = {
    CURRENT_STEP_REQUEST: "environment/CURRENT_STEP_REQUEST",
    CURRENT_STEP_SUCCESS: "environment/CURRENT_STEP_SUCCESS",
    CURRENT_STEP_FAILURE: "environment/CURRENT_STEP_FAILURE",

    UPLOAD_DOCUMENT_REQUEST: "environment/UPLOAD_DOCUMENT_REQUEST",
    UPLOAD_DOCUMENT_SUCCESS: "environment/UPLOAD_DOCUMENT_SUCCESS",
    UPLOAD_DOCUMENT_FAILURE: "environment/UPLOAD_DOCUMENT_FAILURE",
    UPLOAD_DOCUMENT_RESET: "environment/UPLOAD_DOCUMENT_RESET",

    // GENERAL_DATA
    SET_GENERAL_DATA_BACKUP: "environment/SET_GENERAL_DATA_BACKUP",

    GENERAL_DATA_SELECTORS_REQUEST: "environment/GENERAL_DATA_SELECTORS_REQUEST",
    GENERAL_DATA_SELECTORS_SUCCESS: "environment/GENERAL_DATA_SELECTORS_SUCCESS",
    GENERAL_DATA_SELECTORS_FAILURE: "environment/GENERAL_DATA_SELECTORS_FAILURE",

    SAVE_GENERAL_DATA_REQUEST: "environment/SAVE_GENERAL_DATA_REQUEST",
    SAVE_GENERAL_DATA_SUCCESS: "environment/SAVE_GENERAL_DATA_SUCCESS",
    SAVE_GENERAL_DATA_FAILURE: "environment/SAVE_GENERAL_DATA_FAILURE",

    SET_GENERAL_DATA_REQUEST: "environment/SET_GENERAL_DATA_REQUEST",

    // COMPLEMENTARY_DATA
    COMPLEMENTARY_DATA_SELECTORS_REQUEST: "environment/COMPLEMENTARY_DATA_SELECTORS_REQUEST",
    COMPLEMENTARY_DATA_SELECTORS_SUCCESS: "environment/COMPLEMENTARY_DATA_SELECTORS_SUCCESS",
    COMPLEMENTARY_DATA_SELECTORS_FAILURE: "environment/COMPLEMENTARY_DATA_SELECTORS_FAILURE",

    UIF_DETAILS_REQUEST: "environment/UIF_DETAILS_REQUEST",
    UIF_DETAILS_SUCCESS: "environment/UIF_DETAILS_SUCCESS",
    UIF_DETAILS_FAILURE: "environment/UIF_DETAILS_FAILURE",

    // SAVE_COMPLEMENTARY_DATA_REQUEST: "environment/SAVE_COMPLEMENTARY_DATA_REQUEST",
    // SAVE_COMPLEMENTARY_DATA_SUCCESS: "environment/SAVE_COMPLEMENTARY_DATA_SUCCESS",
    // SAVE_COMPLEMENTARY_DATA_FAILURE: "environment/SAVE_COMPLEMENTARY_DATA_FAILURE",
    // SET_COMPLEMENTARY_DATA_BACKUP: "environment/SET_COMPLEMENTARY_DATA_BACKUP",

    SET_COMPLEMENTARY_DATA_REQUEST: "environment/SET_COMPLEMENTARY_DATA_REQUEST",

    // TAX_DATA
    SET_TAX_DATA_BACKUP: "environment/SET_TAX_DATA_BACKUP",
    SET_TAX_DATA_REQUEST: "environment/SET_TAX_DATA_REQUEST",

    // LEGAL_REPRESENTATIVE
    SET_LEGAL_REPRESENTATIVE_BACKUP: "environment/SET_LEGAL_REPRESENTATIVE_BACKUP",
    SET_LEGAL_REPRESENTATIVE_REQUEST: "environment/SET_LEGAL_REPRESENTATIVE_REQUEST",

    SAVE_LEGAL_REPRESENTATIVE_REQUEST: "environment/SAVE_LEGAL_REPRESENTATIVE_REQUEST",
    SAVE_LEGAL_REPRESENTATIVE_SUCCESS: "environment/SAVE_LEGAL_REPRESENTATIVE_SUCCESS",
    SAVE_LEGAL_REPRESENTATIVE_FAILURE: "environment/SAVE_LEGAL_REPRESENTATIVE_FAILURE",

    // SHAREHOLDERS
    SET_SHAREHOLDERS_BACKUP: "environment/SET_SHAREHOLDERS_BACKUP",
    SET_SHAREHOLDERS_REQUEST: "environment/SET_SHAREHOLDERS_REQUEST",

    SAVE_SHAREHOLDERS_REQUEST: "environment/SAVE_SHAREHOLDERS_REQUEST",
    SAVE_SHAREHOLDERS_SUCCESS: "environment/SAVE_SHAREHOLDERS_SUCCESS",
    SAVE_SHAREHOLDERS_FAILURE: "environment/SAVE_SHAREHOLDERS_FAILURE",

    DELETE_SHAREHOLDERS_REQUEST: "environment/DELETE_SHAREHOLDERS_REQUEST",
    DELETE_SHAREHOLDERS_SUCCESS: "environment/DELETE_SHAREHOLDERS_SUCCESS",
    DELETE_SHAREHOLDERS_FAILURE: "environment/DELETE_SHAREHOLDERS_FAILURE",

    VERIFY_PERSON_REQUEST: "environment/VERIFY_PERSON_REQUEST",
    VERIFY_PERSON_SUCCESS: "environment/VERIFY_PERSON_SUCCESS",
    VERIFY_PERSON_FAILURE: "environment/VERIFY_PERSON_FAILURE",
    VERIFY_PERSON_RESET: "environment/VERIFY_PERSON_RESET",

    // PROXIES
    SET_PROXIES_BACKUP: "environment/SET_PROXIES_BACKUP",
    SET_PROXIES_REQUEST: "environment/SET_PROXIES_REQUEST",

    // BENEFICIARIES
    BENEFICIARIES_SELECTORS_REQUEST: "environment/BENEFICIARIES_SELECTORS_REQUEST",
    BENEFICIARIES_SELECTORS_SUCCESS: "environment/BENEFICIARIES_SELECTORS_SUCCESS",
    BENEFICIARIES_SELECTORS_FAILURE: "environment/BENEFICIARIES_SELECTORS_FAILURE",

    REQUEST_LIST_STATES: "environment/REQUEST_LIST_STATES",
    FAILURE_LIST_STATES: "environment/FAILURE_LIST_STATES",
    SUCCESS_LIST_STATES: "environment/SUCCESS_LIST_STATES",
    CLEAN_LIST_STATES: "environment/CLEAN_LIST_STATES",

    RESET_LIST_SHAREHOLDERS_BENEFICIARIES: "environment/RESET_LIST_SHAREHOLDERS_BENEFICIARIES",

    REQUEST_LIST_SHAREHOLDERS_BENEFICIARIES: "environment/REQUEST_LIST_SHAREHOLDERS_BENEFICIARIES",
    FAILURE_LIST_SHAREHOLDERS_BENEFICIARIES: "environment/FAILURE_LIST_SHAREHOLDERS_BENEFICIARIES",
    SUCCESS_LIST_SHAREHOLDERS_BENEFICIARIES: "environment/SUCCESS_LIST_SHAREHOLDERS_BENEFICIARIES",

    SET_SHAREHOLDERS_BENEFICIARIES: "environment/SET_SHAREHOLDERS_BENEFICIARIES",
    SET_BENEFICIARES_BACKUP: "environment/SET_BENEFICIARES_BACKUP",

    SAVE_BENEFICIARIES_REQUEST: "environment/SAVE_BENEFICIARIES_REQUEST",
    SAVE_BENEFICIARIES_SUCCESS: "environment/SAVE_BENEFICIARIES_SUCCESS",
    SAVE_BENEFICIARIES_FAILURE: "environment/SAVE_BENEFICIARIES_FAILURE",
    SAVE_BENEFICIARIES_RESET: "environment/SAVE_BENEFICIARIES_RESET",

    // DOCUMENTATION
    SET_DOCUMENTATION_BACKUP: "environment/SET_DOCUMENTATION_BACKUP",
    SET_DOCUMENTATION_REQUEST: "environment/SET_DOCUMENTATION_REQUEST",

    SAVE_DOCUMENTATION_REQUEST: "environment/SAVE_DOCUMENTATION_REQUEST",
    SAVE_DOCUMENTATION_SUCCESS: "environment/SAVE_DOCUMENTATION_SUCCESS",
    SAVE_DOCUMENTATION_FAILURE: "environment/SAVE_DOCUMENTATION_FAILURE",

    SAVE_PROXIES_REQUEST: "environment/SAVE_PROXIES_REQUEST",
    SAVE_PROXIES_SUCCESS: "environment/SAVE_PROXIES_SUCCESS",
    SAVE_PROXIES_FAILURE: "environment/SAVE_PROXIES_FAILURE",

    VERIFY_TAX_SELECTOR_REQUEST: "environment/VERIFY_TAX_SELECTOR_REQUEST",
    VERIFY_TAX_SELECTOR_SUCCESS: "environment/VERIFY_TAX_SELECTOR_SUCCESS",
    VERIFY_TAX_SELECTOR_FAILURE: "environment/VERIFY_TAX_SELECTOR_FAILURE",

    SAVE_TAX_REQUEST: "environment/SAVE_TAX_REQUEST",
    SAVE_TAX_SUCCESS: "environment/SAVE_TAX_SUCCESS",
    SAVE_TAX_FAILURE: "environment/SAVE_TAX_FAILURE",

    GET_STEP_DATA_REQUEST: "environment/GET_STEP_DATA_REQUEST",
    GET_STEP_DATA_SUCCESS: "environment/GET_STEP_DATA_SUCCESS",
    GET_STEP_DATA_FAILURE: "environment/GET_STEP_DATA_FAILURE",

    SET_LOADING: "environment/SET_LOADING",

    RESTART_ENVIRONMENT_STORE: "environment/RESTART_ENVIRONMENT_STORE",

    // MULTI ROLE PERSON VERIFICATION
    VERIFY_PERSON_ROLES_REQUEST: "environment/VERIFY_PERSON_ROLES_REQUEST",
    VERIFY_PERSON_ROLES_SUCCESS: "environment/VERIFY_PERSON_ROLES_SUCCESS",
    VERIFY_PERSON_ROLES_FAILURE: "environment/VERIFY_PERSON_ROLES_FAILURE",
    VERIFY_PERSON_ROLES_RESET: "environment/VERIFY_PERSON_ROLES_RESET",

    ACCEPT_PAYWAY_REQUEST: "environment/ACCEPT_PAYWAY_REQUEST",
    ACCEPT_PAYWAY_FAILURE: "environment/ACCEPT_PAYWAY_FAILURE",
    ACCEPT_PAYWAY_SUCCESS: "environment/ACCEPT_PAYWAY_SUCCESS",

    SELECT_PAYWAY_TERMINAL_TYPE_REQUEST: "environment/SELECT_PAYWAY_TERMINAL_TYPE_REQUEST",
    SELECT_PAYWAY_TERMINAL_TYPE_FAILURE: "environment/SELECT_PAYWAY_TERMINAL_TYPE_FAILURE",
    SELECT_PAYWAY_TERMINAL_TYPE_SUCCESS: "environment/SELECT_PAYWAY_TERMINAL_TYPE_SUCCESS",

    GET_IS_PAYWAY_ACCEPTED_REQUEST: "environment/GET_IS_PAYWAY_ACCEPTED_REQUEST",
    GET_IS_PAYWAY_ACCEPTED_FAILURE: "environment/GET_IS_PAYWAY_ACCEPTED_FAILURE",
    GET_IS_PAYWAY_ACCEPTED_SUCCESS: "environment/GET_IS_PAYWAY_ACCEPTED_SUCCESS",

    GET_PAYWAY_CATEGORIES_REQUEST: "environment/GET_PAYWAY_CATEGORIES_REQUEST",
    GET_PAYWAY_CATEGORIES_FAILURE: "environment/GET_PAYWAY_CATEGORIES_FAILURE",
    GET_PAYWAY_CATEGORIES_SUCCESS: "environment/GET_PAYWAY_CATEGORIES_SUCCESS",

    VERIFY_ACCEPTED_TYC_REQUEST: "environment/VERIFY_ACCEPTED_TYC_REQUEST",
    VERIFY_ACCEPTED_TYC_FAILURE: "environment/VERIFY_ACCEPTED_TYC_FAILURE",
    VERIFY_ACCEPTED_TYC_SUCCESS: "environment/VERIFY_ACCEPTED_TYC_SUCCESS",

    SAVE_PAYWAY_CATEGORY_REQUEST: "environment/SAVE_PAYWAY_CATEGORY_REQUEST",
    SAVE_PAYWAY_CATEGORY_FAILURE: "environment/SAVE_PAYWAY_CATEGORY_FAILURE",
    SAVE_PAYWAY_CATEGORY_SUCCESS: "environment/SAVE_PAYWAY_CATEGORY_SUCCESS",

    SAVE_PAYWAY_TERMINALS_DATA_REQUEST: "environment/SAVE_PAYWAY_TERMINALS_DATA_REQUEST",
    SAVE_PAYWAY_TERMINALS_DATA_FAILURE: "environment/SAVE_PAYWAY_TERMINALS_DATA_FAILURE",
    SAVE_PAYWAY_TERMINALS_DATA_SUCCESS: "environment/SAVE_PAYWAY_TERMINALS_DATA_SUCCESS",

    PAYWAY_LAST_STEP_REQUEST: "environment/PAYWAY_LAST_STEP_REQUEST",
    PAYWAY_LAST_STEP_FAILURE: "environment/PAYWAY_LAST_STEP_FAILURE",
    PAYWAY_LAST_STEP_SUCCESS: "environment/PAYWAY_LAST_STEP_SUCCESS",

    SET_PAYWAY_TERMINAL_TYPE_BACKUP: "environment/SET_PAYWAY_TERMINAL_TYPE_BACKUP",
    SET_PAYWAY_CATEGORY_BACKUP: "environment/SET_PAYWAY_CATEGORY_BACKUP",
    SET_PAYWAY_TERMINALS_DATA_BACKUP: "environment/SET_PAYWAY_TERMINALS_DATA_BACKUP",
};

export const STATUS = {
    INITIAL: "INITIAL",
    FETCHING: "FETCHING",
    SUCCESS: "SUCCESS",
    FAILURE: "FAILURE",
};

export const INITIAL_STATE = {
    fetching: false,

    currentStepRequest: { status: "INITIAL", value: "", error: null },
    documentToUploadRequest: { status: "INITIAL", value: "", error: null, id: null },

    generalDataSelectorsRequest: { status: "INITIAL", value: "", error: null },
    generalDataBackup: {
        cuit: null,
        companyName: null,
        landline: null,
        internal: null,
        phone: null,
        companyEmail: null,
        taxResidence: {
            country: null,
            province: null,
            locality: null,
            street: null,
            streetNumber: null,
            floor: null,
            apartment: null,
            postalCode: null,
        },
        legalResidence: {
            country: null,
            province: null,
            locality: null,
            street: null,
            streetNumber: null,
            floor: null,
            apartment: null,
            postalCode: null,
        },
    },
    generalDataRequest: { status: "INITIAL", value: "", error: null },

    // complementaryDataBackup: {
    //     inscriptionDate: null,
    //     inscriptionNumber: null,
    //     regulatoryEntity: null,
    //     fatca: null,
    //     fatcaCountry: null,
    //     fatcaCategory: null,
    //     giinNumber: null,
    //     crsOrOcde: null,
    //     crsOrOcdeCountry: null,
    //     crsOrOcdeCategory: null,
    //     legalNumber: null,
    //     economicGroup: null,
    //     groupName: null,
    //     numOfCompanies: null,
    // },
    // complementaryDataRequest: { status: "INITIAL", value: null, error: null },
    complementaryDataSelectorsRequest: { status: "INITIAL", value: null, error: null },
    uifDetailsRequest: { status: "INITIAL", value: null, error: null },

    taxDataBackup: {},
    taxDataRequest: { status: "INITIAL", value: null, error: null },

    legalRepresentativeBackup: null,
    legalRepresentativeRequest: { status: "INITIAL", value: null, error: null },

    shareholdersBackup: null,
    shareholdersRequest: { status: "INITIAL", value: null, error: null },
    verifyPersonRequest: { status: "INITIAL", value: "", error: null, id: null },

    proxiesBackup: null,
    beneficiariesBackup: null,
    proxiesRequest: { status: "INITIAL", value: null, error: null },

    beneficiariesSelectors: {
        status: STATUS.INITIAL,
        countrySelector: [],
        pepJobsSelector: [],
        pepRelationshipTypesSelector: [],
        categoriesFATCASelector: [],
        categoriesCRSOCDESelector: [],
    },

    stateList: [],

    shareholdersBeneficiaries: [],

    beneficiariesRequest: { status: STATUS.INITIAL, value: null, error: null },

    documentationBackup: null,
    documentationRequest: { status: "INITIAL", value: null, error: null },

    proxyRequest: { status: "INITIAL", value: null, error: null },

    taxSelectorRequest: { status: "INITIAL", value: null, error: null },

    taxRequest: { status: "INITIAL", value: null, error: null },

    errorMessage: "",

    verifyPersonRolesRequest: { status: "INITIAL", value: "", error: null, id: null },

    isPaywayAccepted: null,

    paywayCategories: [],

    areTyCAccepted: false,

    paywayTerminalTypeBackup: null,
    paywayCategoryBackup: null,
    paywayTerminalsDataBackup: null,
};

export default (state = INITIAL_STATE, action = {}) => {
    const {
        currentStepRequest,
        documentToUploadRequest,
        documentCode,

        generalDataSelectorsRequest,
        generalDataBackup,
        generalDataRequest,

        complementaryDataBackup,
        complementaryDataSelectorsRequest,
        uifDetailsRequest,
        complementaryDataRequest,

        taxDataBackup,
        taxDataRequest,

        legalRepresentativeBackup,
        legalRepresentativeRequest,

        shareholdersBackup,
        shareholdersRequest,
        verifyPersonRequest,
        documentNumber,

        proxiesBackup,
        proxiesRequest,

        beneficiariesSelectors,
        shareholdersBeneficiaries,
        beneficiariesBackup,
        shareholdersbeneficiariesAdded,
        beneficiariesRequest,

        documentationBackup,
        documentationRequest,
        proxyRequest,
        taxSelectorRequest,
        taxRequest,
        errorMessage,
        fetching,

        verifyPersonRolesRequestValue,

        isPaywayAccepted,
        paywayCategories,
        hasAcceptedPJTerms,

        paywayTerminalTypeBackup,
        paywayCategoryBackup,
        paywayTerminalsDataBackup,
    } = action;

    switch (action.type) {
        case types.SET_LOADING:
            return {
                ...state,
                fetching,
            };
        case types.CURRENT_STEP_REQUEST:
            return {
                ...state,
                currentStepRequest: { status: "FETCHING", value: "", error: null },
            };
        case types.CURRENT_STEP_SUCCESS:
            return {
                ...state,
                currentStepRequest: {
                    status: "SUCCESS",
                    value: currentStepRequest,
                    error: null,
                },
            };
        case types.CURRENT_STEP_FAILURE:
            return {
                ...state,
                currentStepRequest: {
                    status: "FAILURE",
                    value: "",
                    error: currentStepRequest,
                },
            };

        case types.UPLOAD_DOCUMENT_REQUEST:
            return {
                ...state,
                documentToUploadRequest: { status: "FETCHING", value: "", error: null, id: documentCode },
            };
        case types.UPLOAD_DOCUMENT_SUCCESS:
            return {
                ...state,
                documentToUploadRequest: {
                    status: "SUCCESS",
                    value: documentToUploadRequest,
                    error: null,
                    id: documentCode,
                },
            };
        case types.UPLOAD_DOCUMENT_FAILURE:
            return {
                ...state,
                documentToUploadRequest: {
                    status: "FAILURE",
                    value: "",
                    error: documentToUploadRequest,
                    id: documentCode,
                },
            };
        case types.UPLOAD_DOCUMENT_RESET:
            return {
                ...state,
                documentToUploadRequest: { status: "INITIAL", value: "", error: null, id: null },
            };

        // GENERAL_DATA
        case types.GENERAL_DATA_SELECTORS_REQUEST:
            return {
                ...state,
                generalDataSelectorsRequest: { status: "FETCHING", value: "", error: null },
            };
        case types.GENERAL_DATA_SELECTORS_SUCCESS:
            return {
                ...state,
                generalDataSelectorsRequest: {
                    status: "SUCCESS",
                    value: generalDataSelectorsRequest,
                    error: null,
                },
            };
        case types.GENERAL_DATA_SELECTORS_FAILURE:
            return {
                ...state,
                generalDataSelectorsRequest: {
                    status: "FAILURE",
                    value: "",
                    error: generalDataSelectorsRequest,
                },
            };
        case types.SET_GENERAL_DATA_BACKUP:
            return { ...state, generalDataBackup };
        case types.SET_GENERAL_DATA_REQUEST:
            return { ...state, generalDataRequest };
        case types.SAVE_GENERAL_DATA_REQUEST:
            return {
                ...state,
                generalDataRequest: { status: "FETCHING", value: "", error: null },
            };
        case types.SAVE_GENERAL_DATA_SUCCESS:
            return {
                ...state,
                generalDataRequest: { status: "SUCCESS", value: generalDataRequest, error: null },
            };
        case types.SAVE_GENERAL_DATA_FAILURE:
            return {
                ...state,
                generalDataRequest: { status: "FAILURE", value: "", error: generalDataRequest },
            };

        // COMPLEMENTARY_DATA
        case types.SET_COMPLEMENTARY_DATA_BACKUP:
            return { ...state, complementaryDataBackup };

        case types.COMPLEMENTARY_DATA_SELECTORS_REQUEST:
            return {
                ...state,
                complementaryDataSelectorsRequest: { status: "FETCHING", value: "", error: null },
            };
        case types.COMPLEMENTARY_DATA_SELECTORS_SUCCESS:
            return {
                ...state,
                complementaryDataSelectorsRequest: {
                    status: "SUCCESS",
                    value: complementaryDataSelectorsRequest,
                    error: null,
                },
            };
        case types.COMPLEMENTARY_DATA_SELECTORS_FAILURE:
            return {
                ...state,
                complementaryDataSelectorsRequest: {
                    status: "FAILURE",
                    value: "",
                    error: complementaryDataSelectorsRequest,
                },
            };
        case types.SET_COMPLEMENTARY_DATA_REQUEST:
            return { ...state, complementaryDataRequest };

        case types.UIF_DETAILS_REQUEST:
            return {
                ...state,
                uifDetailsRequest: { status: "FETCHING", value: "", error: null },
            };
        case types.UIF_DETAILS_SUCCESS:
            return {
                ...state,
                uifDetailsRequest: { status: "SUCCESS", value: uifDetailsRequest, error: null },
            };
        case types.UIF_DETAILS_FAILURE:
            return {
                ...state,
                uifDetailsRequest: { status: "FAILURE", value: "", error: uifDetailsRequest },
            };

        // case types.SAVE_COMPLEMENTARY_DATA_REQUEST:
        //     return {
        //         ...state,
        //         complementaryDataRequest: { status: "FETCHING", value: "", error: null },
        //     };
        case types.SAVE_COMPLEMENTARY_DATA_SUCCESS:
            return {
                ...state,
                complementaryDataRequest: { status: "SUCCESS", value: complementaryDataRequest, error: null },
            };
        case types.SAVE_COMPLEMENTARY_DATA_FAILURE:
            return {
                ...state,
                complementaryDataRequest: { status: "FAILURE", value: "", error: complementaryDataRequest },
            };

        // TAX_DATA
        case types.SET_TAX_DATA_BACKUP:
            return { ...state, taxDataBackup };
        case types.SET_TAX_DATA_REQUEST:
            return { ...state, taxDataRequest, taxRequest: taxDataRequest };

        // LEGAL_REPRESENTATIVE
        case types.SET_LEGAL_REPRESENTATIVE_BACKUP:
            return { ...state, legalRepresentativeBackup };
        case types.SET_LEGAL_REPRESENTATIVE_REQUEST:
            return { ...state, legalRepresentativeRequest };
        case types.SAVE_LEGAL_REPRESENTATIVE_REQUEST:
            return {
                ...state,
                legalRepresentativeRequest: { status: "FETCHING", value: "", error: null },
            };
        case types.SAVE_LEGAL_REPRESENTATIVE_SUCCESS:
            return {
                ...state,
                legalRepresentativeRequest: { status: "SUCCESS", value: legalRepresentativeRequest, error: null },
            };
        case types.SAVE_LEGAL_REPRESENTATIVE_FAILURE:
            return {
                ...state,
                legalRepresentativeRequest: { status: "FAILURE", value: "", error: legalRepresentativeRequest },
                errorMessage,
            };

        // SHAREHOLDERS
        case types.SET_SHAREHOLDERS_BACKUP:
            return { ...state, shareholdersBackup };
        case types.SET_SHAREHOLDERS_REQUEST:
            return { ...state, shareholdersRequest };
        case types.SAVE_SHAREHOLDERS_REQUEST:
            return {
                ...state,
                shareholdersRequest: { status: "FETCHING", value: "", error: null },
            };
        case types.SAVE_SHAREHOLDERS_SUCCESS:
            return {
                ...state,
                shareholdersRequest: { status: "SUCCESS", value: shareholdersRequest, error: null },
            };
        case types.SAVE_SHAREHOLDERS_FAILURE:
            return {
                ...state,
                shareholdersRequest: { status: "FAILURE", value: "", error: shareholdersRequest },
            };
        case types.DELETE_SHAREHOLDERS_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.DELETE_SHAREHOLDERS_SUCCESS:
            return {
                ...state,
                fetching: false,
            };
        case types.DELETE_SHAREHOLDERS_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.VERIFY_PERSON_REQUEST:
            return {
                ...state,
                verifyPersonRequest: { status: "FETCHING", value: "", error: null, id: documentNumber },
            };
        case types.VERIFY_PERSON_SUCCESS:
            return {
                ...state,
                verifyPersonRequest: { status: "SUCCESS", value: verifyPersonRequest, error: null, id: documentNumber },
            };
        case types.VERIFY_PERSON_FAILURE:
            return {
                ...state,
                verifyPersonRequest: { status: "FAILURE", value: "", error: verifyPersonRequest, id: documentNumber },
            };
        case types.VERIFY_PERSON_RESET:
            return {
                ...state,
                verifyPersonRequest: { status: "INITIAL", value: "", error: null, id: null },
            };

        // PROXIES
        case types.SET_PROXIES_BACKUP:
            return { ...state, proxiesBackup };
        case types.SET_PROXIES_REQUEST:
            return { ...state, proxiesRequest, proxyRequest: proxiesRequest };

        // BENEFICIARIES
        case types.BENEFICIARIES_SELECTORS_REQUEST:
            return { ...state, fetching: true };
        case types.BENEFICIARIES_SELECTORS_FAILURE:
            return { ...state, fetching: false };
        case types.BENEFICIARIES_SELECTORS_SUCCESS:
            return { ...state, fetching: false, beneficiariesSelectors };

        case types.REQUEST_LIST_STATES:
            return { ...state, fetching: true };

        case types.SUCCESS_LIST_STATES:
            return { ...state, stateList: action.states, fetching: false };

        case types.FAILURE_LIST_STATES:
            return {
                ...state,
                fetching: false,
            };
        case types.CLEAN_LIST_STATES:
            return {
                ...state,
                stateList: [],
            };

        case types.REQUEST_LIST_SHAREHOLDERS_BENEFICIARIES:
            return { ...state, fetching: true };
        case types.FAILURE_LIST_SHAREHOLDERS_BENEFICIARIES:
            return { ...state, fetching: false };
        case types.SUCCESS_LIST_SHAREHOLDERS_BENEFICIARIES:
            return { ...state, fetching: false, shareholdersBeneficiaries };

        case types.SET_SHAREHOLDERS_BENEFICIARIES:
            return { ...state, fetching: false, shareholdersBeneficiaries: shareholdersbeneficiariesAdded };

        case types.SET_BENEFICIARES_BACKUP:
            return { ...state, fetching: false, beneficiariesBackup };

        case types.SAVE_BENEFICIARIES_REQUEST:
            return {
                ...state,
                complementaryDataRequest: { status: STATUS.FETCHING, value: "", error: null },
            };
        case types.SAVE_BENEFICIARIES_SUCCESS:
            return {
                ...state,
                beneficiariesRequest: { status: STATUS.SUCCESS, value: beneficiariesRequest, error: null },
            };
        case types.SAVE_BENEFICIARIES_FAILURE:
            return {
                ...state,
                beneficiariesRequest: { status: STATUS.FAILURE, value: "", error: beneficiariesRequest },
            };
        case types.SAVE_BENEFICIARIES_RESET:
            return {
                ...state,
                beneficiariesRequest: { status: STATUS.INITIAL, value: "", error: null },
            };

        case types.RESET_LIST_SHAREHOLDERS_BENEFICIARIES:
            return { ...state, shareholdersBeneficiaries: [] };

        // DOCUMENTATION
        case types.SET_DOCUMENTATION_BACKUP:
            return { ...state, fetching: false, documentationBackup };
        case types.SET_DOCUMENTATION_REQUEST:
            return { ...state, documentationRequest };
        case types.SAVE_DOCUMENTATION_REQUEST:
            return {
                ...state,
                documentationRequest: { status: "FETCHING", value: "", error: null },
            };
        case types.SAVE_DOCUMENTATION_SUCCESS:
            return {
                ...state,
                documentationRequest: { status: "SUCCESS", value: documentationRequest, error: null },
            };
        case types.SAVE_DOCUMENTATION_FAILURE:
            return {
                ...state,
                documentationRequest: { status: "FAILURE", value: "", error: documentationRequest },
            };
        case types.SAVE_PROXIES_REQUEST:
            return {
                ...state,
                proxyRequest: { status: "FETCHING", value: "", error: null },
            };
        case types.SAVE_PROXIES_SUCCESS:
            return {
                ...state,
                proxyRequest: { status: "SUCCESS", value: proxyRequest, error: null },
            };
        case types.SAVE_PROXIES_FAILURE:
            return {
                ...state,
                proxyRequest: { status: "FAILURE", value: "", error: proxyRequest },
            };

        case types.VERIFY_TAX_SELECTOR_REQUEST:
            return {
                ...state,
                taxSelectorRequest: { status: "FETCHING", value: "", error: null },
            };
        case types.VERIFY_TAX_SELECTOR_SUCCESS:
            return {
                ...state,
                taxSelectorRequest: { status: "SUCCESS", value: taxSelectorRequest, error: null },
            };
        case types.VERIFY_TAX_SELECTOR_FAILURE:
            return {
                ...state,
                taxSelectorRequest: { status: "FAILURE", value: "", error: taxSelectorRequest },
            };
        case types.SAVE_TAX_REQUEST:
            return {
                ...state,
                taxRequest: { status: "FETCHING", value: "", error: null },
            };
        case types.SAVE_TAX_SUCCESS:
            return {
                ...state,
                taxRequest: { status: "SUCCESS", value: taxRequest, error: null },
            };
        case types.SAVE_TAX_FAILURE:
            return {
                ...state,
                taxRequest: { status: "FAILURE", value: "", error: taxRequest },
            };
        case types.GET_STEP_DATA_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.GET_STEP_DATA_SUCCESS:
            return {
                ...state,
                fetching: false,
            };
        case types.GET_STEP_DATA_FAILURE:
            return {
                ...state,
                fetching: false,
                errorMessage,
            };

        // MULTI ROLE VERIFY PERSON
        case types.VERIFY_PERSON_ROLES_REQUEST:
            return {
                ...state,
                verifyPersonRolesRequest: { status: "FETCHING", value: "", error: null, id: documentNumber },
            };
        case types.VERIFY_PERSON_ROLES_SUCCESS:
            return {
                ...state,
                verifyPersonRolesRequest: {
                    status: "SUCCESS",
                    value: verifyPersonRolesRequestValue,
                    error: null,
                    id: documentNumber,
                },
            };
        case types.VERIFY_PERSON_ROLES_FAILURE:
            return {
                ...state,
                verifyPersonRolesRequest: {
                    status: "FAILURE",
                    value: "",
                    error: verifyPersonRolesRequestValue,
                    id: documentNumber,
                },
            };
        case types.VERIFY_PERSON_ROLES_RESET:
            return {
                ...state,
                verifyPersonRolesRequest: { status: "INITIAL", value: "", error: null, id: null },
            };

        case types.RESTART_ENVIRONMENT_STORE:
            return { ...INITIAL_STATE };

        case types.ACCEPT_PAYWAY_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.ACCEPT_PAYWAY_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.ACCEPT_PAYWAY_SUCCESS:
            return {
                ...state,
                fetching: false,
            };

        case types.SELECT_PAYWAY_TERMINAL_TYPE_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.SELECT_PAYWAY_TERMINAL_TYPE_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.SELECT_PAYWAY_TERMINAL_TYPE_SUCCESS:
            return {
                ...state,
                fetching: false,
            };
        case types.GET_IS_PAYWAY_ACCEPTED_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.GET_IS_PAYWAY_ACCEPTED_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.GET_IS_PAYWAY_ACCEPTED_SUCCESS:
            return {
                ...state,
                fetching: false,
                isPaywayAccepted,
            };
        case types.GET_PAYWAY_CATEGORIES_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.GET_PAYWAY_CATEGORIES_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.GET_PAYWAY_CATEGORIES_SUCCESS:
            return {
                ...state,
                fetching: false,
                paywayCategories: paywayCategories.reduce(
                    (newList, { id_category, category_name }) => [
                        ...newList,
                        { value: id_category, label: category_name },
                    ],
                    [],
                ),
            };
        case types.VERIFY_ACCEPTED_TYC_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.VERIFY_ACCEPTED_TYC_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.VERIFY_ACCEPTED_TYC_SUCCESS:
            return {
                ...state,
                fetching: false,
                areTyCAccepted: hasAcceptedPJTerms,
            };
        case types.SAVE_PAYWAY_CATEGORY_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.SAVE_PAYWAY_CATEGORY_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.SAVE_PAYWAY_CATEGORY_SUCCESS:
            return {
                ...state,
                fetching: false,
            };
        case types.SAVE_PAYWAY_TERMINALS_DATA_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.SAVE_PAYWAY_TERMINALS_DATA_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.SAVE_PAYWAY_TERMINALS_DATA_SUCCESS:
            return {
                ...state,
                fetching: false,
            };
        case types.PAYWAY_LAST_STEP_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.PAYWAY_LAST_STEP_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.PAYWAY_LAST_STEP_SUCCESS:
            return {
                ...state,
                fetching: false,
            };
        case types.SET_PAYWAY_TERMINAL_TYPE_BACKUP:
            return { ...state, paywayTerminalTypeBackup, fetching: false };
        case types.SET_PAYWAY_CATEGORY_BACKUP:
            return { ...state, paywayCategoryBackup, fetching: false };
        case types.SET_PAYWAY_TERMINALS_DATA_BACKUP:
            return { ...state, paywayTerminalsDataBackup, fetching: false };
        default:
            return state;
    }
};

export const actions = {
    getCurrentStep: () => ({
        type: types.CURRENT_STEP_REQUEST,
    }),
    uploadDocument: (documentToUpload, isOnboarding) => ({
        type: types.UPLOAD_DOCUMENT_REQUEST,
        documentToUpload,
        documentCode: documentToUpload.uploaderRequestId,
        isOnboarding,
    }),
    resetDocumentToUploadRequest: () => ({
        type: types.UPLOAD_DOCUMENT_RESET,
    }),
    setGeneralDataBackup: (generalDataBackup) => ({
        type: types.SET_GENERAL_DATA_BACKUP,
        generalDataBackup,
    }),
    getGeneralDataSelectors: () => ({
        type: types.GENERAL_DATA_SELECTORS_REQUEST,
        guestFlow: false,
    }),
    setGeneralDataRequest: (generalDataRequest) => ({
        type: types.SET_GENERAL_DATA_REQUEST,
        generalDataRequest,
    }),
    saveGeneralData: (generalData, UIFDetails) => ({
        type: types.SAVE_GENERAL_DATA_REQUEST,
        generalData,
        UIFDetails,
    }),

    setComplementaryDataBackup: (complementaryDataBackup) => ({
        type: types.SET_COMPLEMENTARY_DATA_BACKUP,
        complementaryDataBackup,
    }),
    getComplementaryDataSelectors: (documentNumber) => ({
        type: types.COMPLEMENTARY_DATA_SELECTORS_REQUEST,
        documentNumber,
    }),
    verifyUifDetails: (cuit) => ({
        type: types.UIF_DETAILS_REQUEST,
        cuit,
    }),
    // saveComplementaryData: (complementaryData, UIFDetails) => ({
    //     type: types.SAVE_COMPLEMENTARY_DATA_REQUEST,
    //     complementaryData,
    //     UIFDetails,
    // }),
    setComplementaryDataRequest: (complementaryDataRequest) => ({
        type: types.SET_COMPLEMENTARY_DATA_REQUEST,
        complementaryDataRequest,
    }),

    setTaxDataBackup: (taxDataBackup) => ({
        type: types.SET_TAX_DATA_BACKUP,
        taxDataBackup,
    }),
    setTaxDataRequest: (taxDataRequest) => ({
        type: types.SET_TAX_DATA_REQUEST,
        taxDataRequest,
    }),

    setLegalRepresentativeBackup: (legalRepresentativeBackup) => ({
        type: types.SET_LEGAL_REPRESENTATIVE_BACKUP,
        legalRepresentativeBackup,
    }),
    saveLegalRepresentative: (legalRepresentative) => ({
        type: types.SAVE_LEGAL_REPRESENTATIVE_REQUEST,
        legalRepresentative,
    }),
    setLegalRepresentativeRequest: (legalRepresentativeRequest) => ({
        type: types.SET_LEGAL_REPRESENTATIVE_REQUEST,
        legalRepresentativeRequest,
    }),

    setShareholdersBackup: (shareholdersBackup) => ({
        type: types.SET_SHAREHOLDERS_BACKUP,
        shareholdersBackup,
    }),
    saveShareholders: (shareholders) => ({
        type: types.SAVE_SHAREHOLDERS_REQUEST,
        shareholders,
    }),
    setShareholdersRequest: (shareholdersRequest) => ({
        type: types.SET_SHAREHOLDERS_REQUEST,
        shareholdersRequest,
    }),
    verifyPerson: (documentData) => ({
        type: types.VERIFY_PERSON_REQUEST,
        ...documentData,
    }),
    resetVerifyPerson: () => ({
        type: types.VERIFY_PERSON_RESET,
    }),

    setProxiesBackup: (proxiesBackup) => ({
        type: types.SET_PROXIES_BACKUP,
        proxiesBackup,
    }),
    setProxiesRequest: (proxiesRequest) => ({
        type: types.SET_PROXIES_REQUEST,
        proxiesRequest,
    }),

    getBeneficiariesSelectors: () => ({
        type: types.BENEFICIARIES_SELECTORS_REQUEST,
    }),
    listStatesRequest: (countryCode) => ({
        type: types.REQUEST_LIST_STATES,
        countryCode,
    }),
    cleanListStates: () => ({
        type: types.CLEAN_LIST_STATES,
    }),
    listShareholdersBeneficiaries: (setAlreadyFetchShareholders) => ({
        type: types.REQUEST_LIST_SHAREHOLDERS_BENEFICIARIES,
        setAlreadyFetchShareholders,
    }),
    setShareholdersBeneficiaries: (shareholdersbeneficiariesAdded) => ({
        type: types.SET_SHAREHOLDERS_BENEFICIARIES,
        shareholdersbeneficiariesAdded,
    }),
    setBeneficiariesBackup: (beneficiariesBackup) => ({
        type: types.SET_BENEFICIARES_BACKUP,
        beneficiariesBackup,
    }),
    saveBeneficiariesRequest: (beneficiariesRequest) => ({
        type: types.SAVE_BENEFICIARIES_REQUEST,
        beneficiariesRequest,
    }),
    resetBeneficiariesRequest: () => ({
        type: types.SAVE_BENEFICIARIES_RESET,
    }),
    setDocumentationBackup: (documentationBackup) => ({
        type: types.SET_DOCUMENTATION_BACKUP,
        documentationBackup,
    }),
    setDocumentationRequest: (documentationRequest) => ({
        type: types.SET_DOCUMENTATION_REQUEST,
        documentationRequest,
    }),
    saveDocumentation: (documentation) => ({
        type: types.SAVE_DOCUMENTATION_REQUEST,
        documentation,
    }),
    saveProxy: (proxy) => ({
        type: types.SAVE_PROXIES_REQUEST,
        proxy,
    }),
    getTaxSelectorRequest: () => ({
        type: types.VERIFY_TAX_SELECTOR_REQUEST,
    }),
    saveTax: (tax) => ({
        type: types.SAVE_TAX_REQUEST,
        tax,
    }),

    getStepData: (idStep) => ({
        type: types.GET_STEP_DATA_REQUEST,
        idStep,
    }),

    deleteShareholders: (document, role, setState, notificationScope) => ({
        type: types.DELETE_SHAREHOLDERS_REQUEST,
        document,
        role,
        setState,
        notificationScope,
    }),

    restartEnvironmentStore: () => ({
        type: types.RESTART_ENVIRONMENT_STORE,
    }),

    verifyPersonRoles: (cuil, role, isSigner) => ({
        type: types.VERIFY_PERSON_ROLES_REQUEST,
        cuil,
        role,
        isSigner,
    }),
    resetVerifyPersonRoles: () => ({
        type: types.VERIFY_PERSON_ROLES_RESET,
    }),
    resetShareholdersBeneficiaries: () => ({
        type: types.RESET_LIST_SHAREHOLDERS_BENEFICIARIES,
    }),
    acceptPayway: (acceptPayway) => ({
        type: types.ACCEPT_PAYWAY_REQUEST,
        acceptPayway,
    }),
    savePaywayTerminalType: (terminalTypes) => ({
        type: types.SELECT_PAYWAY_TERMINAL_TYPE_REQUEST,
        terminalTypes,
    }),
    verifyPaywayAcceptance: () => ({
        type: types.GET_IS_PAYWAY_ACCEPTED_REQUEST,
    }),
    getPaywayCategories: () => ({
        type: types.GET_PAYWAY_CATEGORIES_REQUEST,
    }),
    verifyTyCAcceptance: () => ({
        type: types.VERIFY_ACCEPTED_TYC_REQUEST,
    }),
    savePaywayCategory: (params) => ({
        type: types.SAVE_PAYWAY_CATEGORY_REQUEST,
        params,
    }),
    savePaywayTerminalsData: (paywayTerminalsData) => ({
        type: types.SAVE_PAYWAY_TERMINALS_DATA_REQUEST,
        paywayTerminalsData,
    }),
    lastStepPayway: () => ({
        type: types.PAYWAY_LAST_STEP_REQUEST,
    }),
    setPaywayTerminalTypeBackup: (paywayTerminalTypeBackup) => ({
        type: types.SET_PAYWAY_TERMINAL_TYPE_BACKUP,
        paywayTerminalTypeBackup,
    }),
    setPaywayCategoryBackup: (paywayCategoryBackup) => ({
        type: types.SET_PAYWAY_CATEGORY_BACKUP,
        paywayCategoryBackup,
    }),
    setPaywayTerminalsDataBackup: (paywayTerminalsDataBackup) => ({
        type: types.SET_PAYWAY_TERMINALS_DATA_BACKUP,
        paywayTerminalsDataBackup,
    }),
};

export const selectors = {
    getFetching: ({ environment }) => environment.fetching,

    getCurrentStepRequest: ({ environment }) => environment.currentStepRequest,
    getDocumentToUploadRequest: ({ environment }) => environment.documentToUploadRequest,

    getGeneralDataSelectorsRequest: ({ environment }) => environment.generalDataSelectorsRequest,
    getGeneralDataBackup: ({ environment }) => environment.generalDataBackup,
    getGeneralDataRequest: ({ environment }) => environment.generalDataRequest,

    getComplementaryDataBackup: ({ environment }) => environment.complementaryDataBackup,
    getComplementaryDataSelectorsRequest: ({ environment }) => environment.complementaryDataSelectorsRequest,
    getUifDetails: ({ environment }) => environment.uifDetailsRequest,
    getComplementaryDataRequest: ({ environment }) => environment.complementaryDataRequest,

    getTaxDataBackup: ({ environment }) => environment.taxDataBackup,
    getTaxRequest: ({ environment }) => environment.taxRequest,

    getLegalRepresentativeBackup: ({ environment }) => environment.legalRepresentativeBackup,
    getLegalRepresentativeRequest: ({ environment }) => environment.legalRepresentativeRequest,

    getShareholdersBackup: ({ environment }) => environment.shareholdersBackup,
    getShareholdersRequest: ({ environment }) => environment.shareholdersRequest,
    getVerifyPersonRequest: ({ environment }) => environment.verifyPersonRequest,

    getProxiesBackup: ({ environment }) => environment.proxiesBackup,
    getProxiesRequest: ({ environment }) => environment.proxyRequest,

    getBeneficiariesSelectors: ({ environment }) => environment.beneficiariesSelectors,

    getBeneficiariesBackup: ({ environment }) => environment.beneficiariesBackup,
    getBeneficiariesRequest: ({ environment }) => environment.beneficiariesRequest,

    getDocumentationBackup: ({ environment }) => environment.documentationBackup,
    getDocumentationRequest: ({ environment }) => environment.documentationRequest,

    getStateList: ({ environment }) => environment.stateList,

    getShareholdersBeneficiaries: ({ environment }) => environment.shareholdersBeneficiaries,
    getTaxSelector: ({ environment }) => environment.taxSelectorRequest,

    getVerifyPersonRolesRequest: ({ environment }) => environment.verifyPersonRolesRequest,

    getIsPaywayAccepted: ({ environment }) => environment.isPaywayAccepted,

    getPaywayCategories: ({ environment }) => environment.paywayCategories,

    getAreTyCAccepted: ({ environment }) => environment.areTyCAccepted,

    getPaywayTerminalTypeBackup: ({ environment }) => environment.paywayTerminalTypeBackup,
    getPaywayCategoryBackup: ({ environment }) => environment.paywayCategoryBackup,
    getPaywayTerminalsDataBackup: ({ environment }) => environment.paywayTerminalsDataBackup,
};
